export default __webpack_public_path__ + "static/media/clouds.a5de6629.mp4";